/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DataModelModule
 */

import { TDependencyToken } from '../utils';

export abstract class NgDependencyInjected {
    protected static readonly ngDependencies: Array<TDependencyToken | string>;

    protected static getNgDependency(dependency: TDependencyToken | string): any {}

    protected getNgDependency(dependency: TDependencyToken | string): any {}
}
